<template>
  <div>
    <click-to-edit
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUANTITY"
      v-model="value.scale.unit_id"
      type="select"
      :disabled="disabled"
      placeholder=""
      select-filterable
      :select-options="scalesUnits"
      select-option-id="id"
      select-option-name="symbol"
      select-cast-value-to-int
      @opened="loadGeneralUnits"
      @input="changed"
    >
    </click-to-edit>

    <div
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUALITY"
      style="display: flex;"
    >
      <click-to-edit
        v-model="value.scale.template_id"
        type="select"
        size="mini"
        placeholder=""
        :disabled="disabled"
        style="width:100%"
        select-filterable
        :select-options="scalesTemplates"
        select-option-id="id"
        select-option-name="name"
        select-cast-value-to-int
        @opened="loadScalesTemplates"
        @input="changed"
      >
      </click-to-edit>
      <cascading-quality-scale-template-edit-modal
        v-if="!disabled"
        :template.sync="value.scale"
        style="margin-left: 5px"
      >
        <el-button
          slot="reference"
          size="small"
          type=""
          plain
          icon="fas fa-pen"
          @click="setCustomScale()"
        ></el-button>
      </cascading-quality-scale-template-edit-modal>
    </div>

  </div>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingQualityScaleTemplatesEditModal
  from "@/modules/cascading/components/scale/CascadingQualityScaleTemplatesEditModal.vue";
import CascadingQualityScaleTemplateEditModal
  from "@/modules/cascading/components/scale/CascadingQualityScaleTemplateEditModal.vue";

export default {
  name: "CascadingScaleUnitSelect",
  components: {CascadingQualityScaleTemplateEditModal, CascadingQualityScaleTemplatesEditModal, ClickToEdit},
  props: {
    value: {}, // whole element
    disabled: {type: Boolean, default: false},
  },

  watch: {
    'value.scale.unit': function (newVal) {
      this.scalesUnits = [];
      if( this.value?.scale?.unit ){
        this.scalesUnits.push(this.value?.scale?.unit);
      }
    },

    'value.scale.template': function (newVal) {
      this.initQualityScaleSelect();
    },
    'value.scale': function (newVal) {
      this.initQualityScaleSelect();
    },
  },
  mounted() {
    if( this.value.scale_type === this.$cascadingConstants.scales.types.TYPE_QUANTITY ){
      if( this.value?.scale?.unit ){
        this.scalesUnits.push(this.value.scale.unit);
      }
    }


    if( this.value.scale_type === this.$cascadingConstants.scales.types.TYPE_QUALITY ){
      this.initQualityScaleSelect();
    }

  },
  data() {
    return {
      scalesUnits: [],
      scalesTemplates: [],
    }
  },
  computed: {},
  methods: {

    initQualityScaleSelect(){
      this.scalesTemplates = [];
      if( this.value?.scale?.template ){
        this.scalesTemplates.push({id:this.value.scale.template.id, name: this.value.scale.template.name});
      }
      this.addCustomScaleToList();
    },

    loadGeneralUnits() {
      this.$api.library.getScalesUnits()
        .then(data => {
          this.scalesUnits = data.scales_units;
        })
    },
    loadScalesTemplates() {
      this.scalesTemplates = [];
      this.$api.cascading.getQualityScaleTemplates()
        .then(data => {
          this.scalesTemplates = data.templates;
          this.addCustomScaleToList();
        })
    },
    addCustomScaleToList(){
      this.scalesTemplates.push({id: 0, name: this.value.scale.name})
    },

    setCustomScale(){
      this.value.scale.template_id = 0;
      this.changed();
    },


    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value)
    }
  },

}
</script>


<style scoped>

</style>